import { memo } from 'react';

import { getScopedTranslate, useScopedTranslate } from '@locale/translate';
import { abbreviateDate } from '@utils/date';

import { TravellerJourneyAction } from 'api/types';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { newDateIgnoreLocalTimezone } from '../timezone';

type ActionType = 'wait_for_time';

export const getDescription = (action: TravellerJourneyAction<ActionType>) => {
  const { t } = getScopedTranslate(nodeLocale);
  const date = action.savedValues?.date
    ? newDateIgnoreLocalTimezone(action.scheduledDate as string)
    : undefined;
  return date
    ? t('triggersNext', { date: abbreviateDate(date, 'en', 'datetime') })
    : t('triggersNextAfter', {
        days: action.values?.days?.value ?? '0',
        hours: action.values?.hours?.value ?? '0',
        minutes: action.values?.minutes?.value ?? '0',
      });
};

export const Node = memo((node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={t('title')}
        descriptionText={node.data.nodeDescription}
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Wait for #',
    noDescription: 'No description',
    triggersNext: 'Triggers next action on {date}',
    triggersNextAfter: 'Triggers next action after {days} days, {hours} hours, {minutes} minutes',
  },
};
